import { FeatureFlag } from '@sonar-software/sonar-core';
import { FileOutlined } from '@ant-design/icons';
import React from 'react';
import { COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
export const logsSubMenu = {
    children: [
        {
            className: 'setup-audit-trail-menu-item',
            feature: FeatureFlag.SetupAuditTrail,
            key: FULL_ROUTES.DATA_SECURITY_SETUP_AUDIT_TRAIL,
            label: COPY_SPECIFIC.SETUP_AUDIT_TRAIL,
            route: FULL_ROUTES.DATA_SECURITY_SETUP_AUDIT_TRAIL
        },
        {
            id: 'timeline-menu-item',
            key: FULL_ROUTES.TIMELINE,
            label: COPY_SPECIFIC.METADATA_TIMELINE,
            route: FULL_ROUTES.TIMELINE
        },
        {
            className: 'monitors-menu-item',
            key: 'monitors',
            label: COPY_SPECIFIC.MONITOR_SETTINGS,
            route: FULL_ROUTES.DATA_SECURITY_MONITORS
        }
    ],
    icon: React.createElement(FileOutlined, null),
    id: 'logs-submenu',
    key: 'logs',
    label: COPY_SPECIFIC.MONITORS_AND_LOGS
};
